<script>
import api from './api'
export default {
  load (id) {
    return api.getData('feeds/' + id)
  },
  save (id, formData) {
    if (!id) {
      return api.post('feeds', formData)
    }
    return api.put('feeds/' + id, formData)
  },
  remove (id) {
    return api.delete('feeds/' + id)
  },
  list (params) {
    return api.get('feeds', params)
  },
  refresh (id) {
    return api.get('feeds/' + id + '/refresh')
  },
  download (id) {
    return api.download('feeds/' + id + '/download')
  }
}
</script>



// WEBPACK FOOTER //
// feed.vue?5fcd2359